import { mainApi } from "../../../../api";

export const tasksQuery = (userClass?: string) => ({
    queryKey: ["tasks"],
    queryFn: async () =>
        mainApi.get("get_exercise_sections/" + userClass ?? ""),
});
